module.exports = "/_next/static/images/1f82f41013fbb37d57799b73ffca1c69-woman-using-cellphone@3x.jpg.webp";